import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Barcode type label',
    defaultMessage: 'Type',
    id: 'ZsGrIC',
  },
});
